import Cookies from 'js-cookie'
import FingerprintJS from '@fingerprintjs/fingerprintjs'

export function getDeviceUUID () {
  let uuid = localStorage.getItem('device-uuid')
  if (uuid == null) {
    // uuid = generateUuid()
    // localStorage.setItem('device-uuid', uuid)
    getFingerprintId().then(visitorId => {
      localStorage.setItem('device-uuid', visitorId)
    })
    uuid = localStorage.getItem('device-uuid')
  }
  const uuid2 = Cookies.get('device-uuid')
  if (uuid != null && uuid != uuid2) {
    Cookies.set('device-uuid', uuid)
  }
  // console.log(uuid)
  return uuid
}

export function generateUuid () {
  return (s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4())
}

function s4 () {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
}

export async function getFingerprintId () {
  const fingerprint = await FingerprintJS.load()
  const result = await fingerprint.get()
  // console.log(result.components)
  // const visitorId = result.visitorId // 默认使用的属性太多了，可以去除一些容易变化的，去生成visitorId
  // 排除变化的属性
  // ES6中的解构赋值语法：将result.components中属性提取audioBaseLatency、canvas等到新变量，...components收集剩下的
  // 相当于排除audioBaseLatency、canvas等属性，去自定义生成visitorId
  const {
    audioBaseLatency, canvas, colorDepth, colorGamut, contrast, cookiesEnabled, deviceMemory,
    domBlockers, fontPreferences, fonts, forcedColors, hardwareConcurrency, languages, localStorage,
    math, monochrome, openDatabase, pdfViewerEnabled, plugins, privateClickMeasurement, reducedMotion,
    reducedTransparency, screenFrame, screenResolution, sessionStorage, touchSupport, vendor, vendorFlavors,
    webGlBasics, webGlExtensions, userAgent,
    ...components
  } = result.components
  const visitorId = FingerprintJS.hashComponents(components)
  if (visitorId.length === 32) {
    // 变成8-4-4-4-12模式的UUID格式
    let uuid = ''
    for (let i = 0; i < visitorId.length; i += 4) {
      const chunk = visitorId.substr(i, 4)
      if (i === 8) {
        uuid += '-'
      } else if (i === 12) {
        uuid += '-'
      } else if (i === 16) {
        uuid += '-'
      } else if (i === 20) {
        uuid += '-'
      }
      uuid += chunk
    }
    return uuid
  }
  return visitorId
}


const authKey = 'Auth-Token'

export function getToken() {
  let loginTime = Cookies.get('login-time');
  let lloginTime = localStorage.getItem('login-time');
  if (lloginTime != loginTime) {
    removeToken();
  }
  return localStorage.getItem(authKey)
}

export function setToken(token) {
  let loginTime = new Date().getTime();
  Cookies.set('login-time', loginTime);
  localStorage.setItem('login-time', loginTime);
  return localStorage.setItem(authKey, token)
}

export function removeToken() {
  return localStorage.removeItem(authKey)
}
